<template>
    <div style="padding: 10px 10px 10px 0;" v-loading="loading">
        <!-- 新增/修改弹框 -->
        <el-dialog :title="title" :visible.sync="show" width="500px" @close="close" :close-on-click-modal="false"
            :close-on-press-escape="false">
            <el-form :model="form" ref="form" label-width="100px">
                <el-form-item label="事件类型" prop="type" :rules="[{ required: true, message: '请输入事件类型' }]">
                    <el-input disabled v-model="form.type" placeholder="请输入事件类型"></el-input>
                </el-form-item>
                <el-form-item label="事件描述" prop="eventDesc" :rules="[{ required: true, message: '请输入事件描述' }]">
                    <el-input disabled v-model="form.eventDesc" placeholder="请输入事件描述"></el-input>
                </el-form-item>
                <el-form-item label="事件等级" prop="grade" :rules="[{ required: true, message: '请输入事件等级' }]">
                    <el-input-number v-model="form.grade" :min="1" :max="10" label="label"></el-input-number>
                </el-form-item>

                <el-form-item label="通知人员类别" prop="notifiedPersonalTypes">
                    <el-select v-model="form.notifiedPersonalTypes" clearable multiple style="width: 100%;"
                        placeholder="请选择通知人员类别">
                        <el-option v-for="item in roleTypeList" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 搜索条件 -->
        <!--  <el-form :inline="true" :model="selectForm" ref="selectForm">
        <el-form-item label="事件类型" prop="areaCode">
                <el-input size="small" v-model="selectForm.areaCode" placeholder="请输入区域编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="等级" prop="areaType">
                <el-select size="small" clearable v-model="selectForm.areaType" style="width:100%" placeholder="请选择等级">
                    <el-option v-for="s in typeList" :label="s" :value="s"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="getQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small"
                    @click="$refs.selectForm.resetFields(); getQuery();">重置</el-button>
            </el-form-item> 
                <el-button type="primary" size="small" @click="addRow">新增</el-button>
            </el-form-item> 
            <el-form-item>
                <el-button type="primary" @click="dc">导出</el-button>
            </el-form-item> 
        </el-form>-->
        <!-- 表格 -->
        <el-table :data="data" style="width: 100%">
            <el-table-column prop="type" label="事件类型" align="center"></el-table-column>
            <el-table-column prop="eventDesc" label="事件描述" align="center"></el-table-column>
            <el-table-column prop="grade" label="等级" align="center"></el-table-column>
            <el-table-column prop="notifiedPersonalTypeName" label="通知人员类别" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <!-- <el-button type="text" @click="setRow(scope.row, 'look')">查看</el-button> -->
                    <el-button type="text" @click="setRow(scope.row, 'set')">编辑</el-button>
                    <!-- <el-button type="text" @click="delRow(scope.row)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
            :page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum" style="margin-top: 10px;">
        </el-pagination>
    </div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
export default {
    data() {
        return {
            loading: false,
            form: { //表单数据
                id: "",
                eventDesc: "",
                grade: 1,
                type: "",
                notifiedPersonalType: "",
                notifiedPersonalTypes: [],
            },
            data: [], //表格数据
            placeList: [],
            selectForm: { //查询条件
                page: 1, //当前页
                rows: 10, //页大小
                areaCode: "", //编号，
                areaName: "",
                areaType: ""
            },
            totalNum: 0, //数据总数
            show: false, //控制弹窗
            title: "编辑",
            roleTypeList: [] //通知人类型
        }
    },
    methods: {
        dc() {
            publicExport("/api/admin/export/uploadSecurityArea", this.selectForm, "区域管理")
        },
        //通知人员
        getRoleType() {
            this.$http.post(`/api/safe/eventGrade/getTypes`, {}).then(res => {
                if (res.data.code == 200) {
                    for (let key in res.data.data) {
                        let data = {
                            label: res.data.data[key],
                            value: key
                        }
                        this.roleTypeList.push(data)
                    }
                }
            })
        },

        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let url = "/api/safe/eventGrade/edit"
                    if (this.title == "新增") {
                        url = "/api/safe/eventGrade/add"
                    }
                    this.$http.post(url, this.form).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.msg);
                            this.show = false
                            this.getAll()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                } else {
                    return false;
                }
            });

        },
        delRow(row) { //删除被点击
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = [];
                ids.push(row.id)
                this.$http.post(`/api/safe/area/delete`, ids).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("删除成功")
                        this.getAll();
                    } else {
                        this.$message.error("删除失败")
                    }
                })
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        addRow() { //新增被点击
            this.title = "新增";
            this.show = true;
        },
        setRow(row, type) { //修改被点击
            let data = JSON.parse(JSON.stringify(row))
            this.form = data;
            if (data.notifiedPersonalType) {
                this.form.notifiedPersonalTypes = data.notifiedPersonalType.split(",");
            }
            this.title = "修改";
            this.show = true;
        },
        close() { //弹框关闭
            this.$refs.form.resetFields()
            this.form = {
                id: "",
                eventDesc: "",
                grade: 1,
                type: "",
                notifiedPersonalType: [],
                notifiedPersonalTypes: [],
            };
        },
        getQuery() {
            this.selectForm.page = 1; //当前页
            this.selectForm.rows = 10;//页大小
            this.getAll();
        },
        getAll() { //获取表格数据
            this.loading = true;
            this.$http.post(`/api/safe/eventGrade/pageQuery`, this.selectForm).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.data = res.data.rows;
                    this.totalNum = res.data.total;
                }
            })
        },
        sizeChange(size) { //页大小被修改
            this.selectForm.rows = size;
            this.getAll();
        },
        currentChange(page) { //当前页被修改
            this.selectForm.page = page;
            this.getAll();
        },
    },
    created() {
        // this.oldForm = JSON.parse(JSON.stringify(this.form))
        this.getAll();
        this.getRoleType();
    }
}
</script>

<style scoped="scoped">
.text-x {
    width: 500px;
    height: 400px;
}
</style>
